module.exports = __webpack_public_path__ + "static/og-6c7b0e6bec23d452b0fdf5b8482388d3.png";